import { IconLock } from '@tabler/icons-react';

import type { NavItemType } from '../types';

export const ACL_STAFF_PATH = '/acl';
export const ACL_ADMIN_PATH = '/admin/acl';

export const getStaffAclNavChildren = (showAcl: boolean): NavItemType[] =>
    showAcl
        ? [
              {
                  id: 'acl',
                  title: 'ACL Management',
                  type: 'item',
                  url: ACL_STAFF_PATH,
                  icon: IconLock,
                  breadcrumbs: false
              }
          ]
        : [];
